import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { backendAccessGet } from "../Utils/Authentication"
import { backendAccessPost } from "../Utils/Authentication"

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

// AdminLogin.js

const handleSubmit = async (e) => {
  e.preventDefault();
  setError('');

  try {
    // ✅ POST to /api/auth/token/ (SimpleJWT)
    const response = await fetch('api/tickets/auth/token/obtain/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(credentials)
    });

    if (!response.ok) {
      throw new Error('Invalid credentials');
    }

    const data = await response.json();

    // ✅ Save JWT tokens AND fetch user info
    const authData = {
      accessToken: data.access,
      refreshToken: data.refresh
    };

    // Fetch user info
    const meResponse = await fetch('api/tickets/auth/me/', {
      headers: { 'Authorization': `Bearer ${data.access}` }
    });
    const user = await meResponse.json();

    // ✅ Save using your Authentication class format
    localStorage.setItem('auth', JSON.stringify(authData));
    localStorage.setItem('me', JSON.stringify(user));

    navigate('/dashboard');
  } catch (err) {
    setError('Invalid username or password.');
  }
};

  return (
    <div style={{ maxWidth: '400px', margin: '100px auto', padding: '30px', fontFamily: 'Arial' }}>
      <h2 style={{ textAlign: 'center', color: '#2c3e50' }}>Admin Login</h2>
      {error && <p style={{ color: '#e74c3c', textAlign: 'center' }}>{error}</p>}
      
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Username:</label>
          <input
            type="text"
            name="username"
            value={credentials.username}
            onChange={handleChange}
            required
            style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Password:</label>
          <input
            type="password"
            name="password"
            value={credentials.password}
            onChange={handleChange}
            required
            style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }}
          />
        </div>

        <button
          type="submit"
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: '#3498db',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: 'bold',
          }}
        >
          Log In
        </button>
      </form>

    </div>
  );
};

export default AdminLogin;